
import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";

function CheckboxesComponent({
  primaryText = "",
  secondaryText = "",
  checkBoxes = [],
  value = [],       // array of currently selected labels
  onChange = () => {}, // callback that toggles the label
}) {
  return (
    <Stack sx={{ py: "16px" }}>
      <Typography
        variant="body2"
        sx={{
          fontSize: "20px",
          fontWeight: "700",
          lineHeight: "24.2px",
          maxWidth: "475px",
          pb: "4px",
        }}
      >
        {primaryText}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: "17px",
          fontWeight: "400",
          lineHeight: "20.57px",
        }}
      >
        {secondaryText}
      </Typography>
      <Box
        display="flex"
        sx={{
          flexDirection: "column",
          pt: "8px",
          gap: "10px",
        }}
      >
        {checkBoxes.map((checkBox, i) => {
          const isChecked = value.includes(checkBox.label);
          return (
            <FormControlLabel
              key={i}
              sx={{
                p: "0px",
                width: "22px",
                height: "22px",
                alignItems: "center",
              }}
              control={
                <Checkbox
                  icon={<Box component="img" src="/icons/emptyCircleIcon.svg" />}
                  checkedIcon={<Box component="img" src="/icons/fillCircleIcon.svg" />}
                  checked={isChecked}
                  onChange={() => onChange(checkBox.label)}
                />
              }
              label={
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "17px",
                    fontWeight: "400",
                    lineHeight: "20.57px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {checkBox.label}
                </Typography>
              }
            />
          );
        })}
      </Box>
    </Stack>
  );
}

export default CheckboxesComponent;
